export default __webpack_public_path__ + "static/media/640.a7398b4b.png";